import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'
import {
    AdditionalFeeSelectorType,
} from 'app/Apps/OrderManagement/Orders/orders.types'

import requests from 'app/requests/ContractBasis/AdditionalFees.requests'

const useLoadLabelAdditionalFee = (id) => {
    return useRequest<AdditionalFeeSelectorType>({
        key: RequestKeys.getAdditionalFeeSelector,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(requests.get),
        enabled: Boolean(id),
    })
}

export default useLoadLabelAdditionalFee
